import { application } from "./application";

import CmdEnterController from "../../shared/controllers/cmd_enter_controller";
application.register("cmd-enter", CmdEnterController);
